import React, { Component } from 'react'
import PT from 'prop-types'
import { Upload } from 'element-react'
import { isEmpty } from 'ramda'
import imagesProp from 'admin-modules/build/proptypes/images'
import { SERVER_URL } from '../constants'

class Uploader extends Component {
  constructor(props) {
    super(props)
    this.uploadingFiles = {}
  }

  handleRef = (ref) => {
    this.upload = ref
  }

  handleBeforeUpload = ({ type, size, name }) => {
    if (this.props.isAudio) {
      const isAudio = type.indexOf('audio/') === 0
      const isSmall = size < 30 * 1024 * 1024
      if (isAudio && isSmall) {
        this.handleFileUploadStart(name)
        return true
      }

      if (!isAudio) {
        // eslint-disable-next-line
        alert('Nesprávny typ súboru')
      } else {
        this.props.onFileSizeLimit(size, true)
      }
      return false
    }

    const isImage = type.indexOf('image/') === 0
    const isSmall = size < 10 * 1024 * 1024
    if (isImage && isSmall) {
      this.handleFileUploadStart(name)
      return true
    }

    if (!isImage) {
      // eslint-disable-next-line
      alert('Nesprávny typ súboru')
    } else {
      this.props.onFileSizeLimit(size, false)
    }
    return false
  }

  handleFileUploadStart = (name) => {
    // console.log('start upload', name)
    this.uploadingFiles = {
      ...this.uploadingFiles,
      [name]: true,
    }
    this.props.onFileUploadStart()
  }

  handleSuccess = (response, file) => {
    // console.log('success!', file.name)
    delete this.uploadingFiles[file.name]
    // console.log(this.uploadingFiles)
    if (isEmpty(this.uploadingFiles)) {
      this.props.onFinishedAllUploads()
    }
  }

  handleUploadError = (error) => {
    if (window.Raven) {
      const type = this.props.isAudio ? 'audio' : 'image'
      window.Raven.captureException(error, {
        extra: `file upload failed type: ${type}`,
      })
    }
  }

  handleRemove = (file) => {
    // console.log('remove', file.name)
    delete this.uploadingFiles[file.name]
    this.props.onFileRemove()
    if (isEmpty(this.uploadFiles)) {
      this.props.onFinishedAllUploads()
    }
  }

  render() {
    const folder = window.location.pathname.startsWith('/89') ? '89' : '68'
    const end = this.props.isAudio ? 'upload-sound' : 'upload'
    const action = `${SERVER_URL}/submit/${end}/${folder}`
    const text = this.props.text || <span>Drop file here or <em>click to upload</em></span>

    return (
      <Upload
        ref={this.handleRef}
        className="uploader"
        action={action}
        beforeUpload={this.handleBeforeUpload}
        onChange={this.props.onChange}
        onRemove={this.handleRemove}
        onSuccess={this.handleSuccess}
        onError={this.handleUploadError}
        fileList={this.props.filesList}
        drag
        multiple={!this.props.isAudio}
        listType={this.props.isAudio ? 'text' : 'picture'}
      >
        <i className="el-icon-upload" />
        <div className="el-upload__text">{text}</div>
      </Upload>
    )
  }
}

Uploader.propTypes = {
  isAudio: PT.bool,
  filesList: PT.arrayOf(PT.shape({
    url: PT.string.isRequired,
    response: imagesProp.isRequired,
  })),
  onFileUploadStart: PT.func.isRequired,
  onFinishedAllUploads: PT.func.isRequired,
  onChange: PT.func.isRequired,
  onFileSizeLimit: PT.func.isRequired,
  onFileRemove: PT.func.isRequired,
  text: PT.node,
}

Uploader.defaultProps = {
  filesList: [],
  isAudio: false,
  text: null,
}

export default Uploader



// WEBPACK FOOTER //
// ./src/components/Uploader.js